var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVideoSmall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 15,
    viewBox: "0 0 22 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 21,
    height: 13.3,
    rx: 2.5,
    fill: "white",
    stroke: "#434341"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.54557 4.45273C9.17269 4.28675 8.7998 4.53572 8.7998 4.86768V9.43212C8.7998 9.76408 9.26591 10.0131 9.54557 9.84707L14.0201 7.60635C14.393 7.44037 14.393 7.02542 14.0201 6.85944L9.54557 4.45273Z",
    fill: "#434341"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoSmall);
export default __webpack_public_path__ + "static/media/video-small.da9478a434faa4aac181800aab158374.svg";
export { ForwardRef as ReactComponent };